import styled from 'styled-components';
import { Select as SelectAntd } from 'antd';
import color from '../../configs/color';

export const Wrapper = styled.div`
  .ant-form-item {
    margin-bottom: 24px;
    .ant-form-item-label {
      padding: 0 0 6px;
      > label {
        color: ${color.black3};
        font-weight: 600;
        font-size: 16px;
        line-height: 142%;
      }
    }
  }
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder,
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
  .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input,
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    height: 44px;
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 44px;
  }

  .ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    padding: 0 4px;
  }
  .ant-btn-ghost {
    color: ${color.blue};
    padding: 0 20px;
    border-color: ${color.blue};
  }
`;

export const SelectUser = styled(SelectAntd)`
  .ant-select-selection-item {
    display: flex;
    .component_accountCard {
      width: 100%;
      padding: 0;
    }
  }
`;

export const OptionRender = styled.div`
  display: flex;
  align-items: center;
  .component_accountCard {
    margin: auto 0;
    width: 100%;
    padding: 6px 4px;
    .ant-avatar {
      height: 32px !important;
      width: 32px !important;
      .ant-avatar-string {
        line-height: 32px !important;
        font-size: 14px;
      }
    }
    .font-paragraph_medium {
      font-size: 16px;
      font-weight: 400;
    }
  }
`;
